<div class="h-full w-full flex flex-column">

    <p-steps [model]="steps" [(activeIndex)]="activeStep"></p-steps>

    <div
        class="flex align-items-center justify-content-center flex-grow-1 lg:col-8 lg:col-offset-2 xl:col-6 xl:col-offset-3 txl:col-4 txl:col-offset-4 py-3">
        <form (ngSubmit)="save()" [formGroup]="form" novalidate class="w-full flex flex-column">
            <div class="grid">
                <div class="col-12" [@stepAnimation]="activeStep">

                    @switch (activeStep) {

                    <!-- Étape de bienvenue -->
                    @case (0) {

                    <div class="w-full">
                        <!-- Message de bienvenue -->
                        <div
                            class="col-12 flex align-items-center justify-content-center text-5xl text-primary font-semibold">
                            Bonjour et bienvenue sur Biifor !
                        </div>

                        <div class="col-12 flex align-items-center justify-content-center text-center">
                            <h2>Vous allez être guidé pour créer votre organisation. Cela ne prendra que quelques
                                secondes.</h2>
                        </div>

                        @if (countries.length) {
                        <div @expandHeight class="w-full">
                            <div class="col-12 flex align-items-center justify-content-center text-center">
                                <h2>Tout d'abord, veuillez sélectionner votre pays :</h2>
                            </div>

                            <!-- Sélection du pays -->
                            <div class="col-12 grid">
                                @for (country of countries; track country.alpha2) {
                                <p-button class="col-6" styleClass="h-full w-full flex justify-content-center"
                                    [outlined]="true" [raised]="true" [disabled]="country.availableSoon"
                                    (click)="onClickCountry(country)">
                                    <div class="flex flex-column align-items-center">
                                        <div class="text-5xl my-2">{{ country.flag }}</div>
                                        <div class="text-2xl my-2">{{ country.name }}</div>
                                        @if (country.availableSoon) {
                                        <div class="text-xs font-italic -mt-2">Disponible prochainement</div>
                                        }
                                    </div>
                                </p-button>
                                }
                            </div>
                        </div>
                        }
                    </div>

                    }

                    <!-- Étape de saisie des données générales de la société -->
                    @case (1) {

                    <div class="w-full">
                        <!-- Numéro d'identification -->
                        @if ((!!client.isCaledonian || !!client.isPolynesian) && !client.organization) {
                        <div class="flex flex-column align-items-center">
                            <div class="col-12 flex align-items-center justify-content-center text-center">
                                @if (!!client.isCaledonian) {
                                <h2>Cherchez votre organisation dans le répertoire RIDET</h2>
                                } @else {
                                <h2>Cherchez votre organisation dans le Répertoire Territorial des Entreprises (RTE)
                                </h2>
                                }
                            </div>
                            <div class="col-12">
                                <app-organization-search-form class="flex-grow-1" [country]="client.country"
                                    (organizationSelected)="onOrganizationSelected($event)"></app-organization-search-form>
                            </div>
                        </div>
                        }

                        @if ((!client.isCaledonian && !client.isPolynesian) || !!client.organization) {

                        <div class="col-12 flex align-items-center justify-content-center text-center">
                            <h2>Dîtes nous en un peu plus</h2>
                        </div>

                        <!-- Nom de la société -->
                        <div class="flex align-items-center">
                            <div class="col-4">
                                <label>Raison sociale @if(!client.organization) {*}</label>
                            </div>
                            <div class="col-8">
                                @if(!client.organization) {
                                <input type="text" formControlName="name" pInputText placeholder="Nom de la société">
                                } @else {
                                <div class="p-2 font-semibold">{{ client.organization.name }}</div>
                                }
                            </div>
                        </div>

                        <!-- Nom commercial -->
                        <div class="flex align-items-center">
                            <div class="col-4 flex align-items-center justify-content-between">
                                <label>Nom commercial</label>
                                <p-button icon="pi pi-info-circle" type="button" [rounded]="true" [text]="true"
                                    (click)="op.toggle($event)"></p-button>
                            </div>
                            <div class="col-8">
                                <input type="text" formControlName="commercialName" pInputText
                                    placeholder="Nom commercial">
                            </div>
                        </div>

                        <!-- Identifiant de la société -->
                        <div class="flex align-items-center">
                            <div class="col-4">
                                @if (!!client.isCaledonian) {

                                <label>Numéro RID</label>
                                } @else if (!!client.isPolynesian) {
                                <label>N° TAHITI</label>
                                } @else {
                                <label>Identifiant de la société @if(!client.organization) {*}</label>
                                }
                            </div>
                            <div class="col-8">
                                @if(!client.organization) {
                                <input type="text" formControlName="identifier" pInputText
                                    placeholder="Identifiant de la société">
                                } @else {
                                <div class="p-2 text-semibold">{{ client.organization.identifier }}</div>
                                }
                            </div>
                        </div>

                        <!-- Forme juridique -->
                        <div class="flex align-items-center">
                            <div class="col-4">
                                <label>Forme juridique *</label>
                            </div>
                            <div class="col-8">
                                <p-select [options]="legalStatuses" formControlName="legalStatus" appendTo="body"
                                    dataKey="code" placeholder="Forme juridique">
                                    <ng-template let-legalStatus pTemplate="selectedItem">
                                        @if (!!legalStatus) {
                                        <span>{{legalStatus.label}}</span>
                                        }
                                    </ng-template>
                                    <ng-template let-legalStatus pTemplate="item">
                                        <span>{{legalStatus.label}}</span>
                                    </ng-template>
                                </p-select>
                            </div>
                        </div>

                        <!-- Activité principale -->
                        <div class="flex align-items-center">
                            <div class="col-4">
                                <label for="input-activity" class="block">Activité principale *</label>
                            </div>
                            <div class="col-8">
                                <p-select [options]="mainActivities" formControlName="mainActivity" filterBy="label"
                                    placeholder="Activité principale">
                                    <ng-template let-item pTemplate="selectedItem">
                                        <span>{{item?.label || ''}}</span>
                                    </ng-template>
                                    <ng-template let-item pTemplate="item">
                                        <span>{{item.label}}</span>
                                    </ng-template>
                                </p-select>
                            </div>
                        </div>

                        <!-- Contexte métier -->
                        <div class="flex align-items-start">
                            <div class="col-4 flex align-items-center justify-content-between">
                                <label class="block">Dites-nous en plus sur vous</label>
                                <p-button icon="pi pi-info-circle" type="button" [rounded]="true" [text]="true"
                                    (click)="opBusinessContext.toggle($event)"></p-button>
                            </div>
                            <div class="col-8">
                                <textarea pTextarea formControlName="businessContext" [rows]="4" class="w-full"
                                    placeholder="Décrivez votre activité, vos clients, vos fournisseurs, vos particularités…"></textarea>
                            </div>
                        </div>

                        <!-- Taille -->
                        <div class="flex align-items-center">
                            <div class="col-4">
                                <label for="input-size" class="block">Taille</label>
                            </div>
                            <div class="col-8">
                                <p-select [options]="sizes" formControlName="size" filterBy="label"
                                    placeholder="Taille de l'entreprise">
                                    <ng-template let-item pTemplate="selectedItem">
                                        <span>{{item?.label || ''}}</span>
                                    </ng-template>
                                    <ng-template let-item pTemplate="item">
                                        <span>{{item.label}}</span>
                                    </ng-template>
                                </p-select>
                            </div>
                        </div>

                        <!-- Fuseau horaire -->
                        <div class="flex align-items-center">
                            <div class="col-4">
                                <label class="block">Fuseau horaire *</label>
                            </div>
                            <div class="col-8">
                                <p-select [options]="timezones" formControlName="timezone" [filter]="true"
                                    filterBy="label" placeholder="Fuseau horaire">
                                    <ng-template let-item pTemplate="selectedItem">
                                        <span>{{item?.label || ''}}</span>
                                    </ng-template>
                                    <ng-template let-item pTemplate="item">
                                        <span>{{item.label}}</span>
                                    </ng-template>
                                </p-select>
                            </div>
                        </div>

                        <!-- Étape suivante -->
                        <div class="col-12 flex justify-content-between">
                            <p-button type="button" severity="secondary" label="Retour" [rounded]="true"
                                (onClick)="previous()"></p-button>
                            <p-button type="button" label="Suivant" [rounded]="true"
                                [disabled]="!form.get('name')?.value || !form.get('legalStatus')?.value || !form.get('mainActivity')?.value"
                                (onClick)="next()"></p-button>
                        </div>

                        }
                    </div>
                    }

                    <!-- Étape de saisie des données fiscales de la société -->
                    @case (2) {

                    <div class="w-full">

                        <div class="col-12 flex flex-column align-items-center justify-content-center text-center">
                            <h2 class="font-italic">“J'ai déjà essayé de payer mes impôts avec le sourire, ils préfèrent
                                un chèque.”</h2>
                            <span class="-mt-3 font-italic text-xs text-400">Jean Yanne</span>
                        </div>

                        <div class="flex align-items-center">
                            <div class="col-12">
                                <p-message>Ne modifiez les paramètres ci-dessous que si vous êtes sûr de vous, sinon
                                    laissez les valeurs par défaut</p-message>
                            </div>
                        </div>

                        <!-- Type d'imposition -->
                        <div class="flex align-items-center">
                            <div class="col-4">
                                <label>Type d'imposition *</label>
                            </div>
                            <div class="col-8">
                                <p-select [options]="taxationTypes" formControlName="taxationType" appendTo="body"
                                    dataKey="code" placeholder="Type d'imposition">
                                    <ng-template let-taxationType pTemplate="selectedItem">
                                        @if (!!taxationType) {
                                        <span>{{taxationType.label}}</span>
                                        }
                                    </ng-template>
                                    <ng-template let-taxationType pTemplate="item">
                                        <span>{{taxationType.label}}</span>
                                    </ng-template>
                                </p-select>
                            </div>
                        </div>

                        <!-- Étape suivante -->
                        <div class="col-12 flex justify-content-between">
                            <p-button type="button" severity="secondary" label="Retour" [rounded]="true"
                                (onClick)="previous()"></p-button>
                            <p-button type="button" label="Suivant" [rounded]="true"
                                [disabled]="!form.get('taxationType')?.value" (onClick)="next()"></p-button>
                        </div>

                    </div>
                    }

                    <!-- Étape de saisie des données de TVA/TGC de la société -->
                    @case (3) {

                    <div class="w-full">
                        <div class="col-12 flex align-items-center justify-content-center text-center">
                            <h2>L'organisation est-elle assujettie à la {{ vatName }} ?</h2>
                        </div>

                        <!-- Sélection du pays -->
                        <div class="col-12 grid">
                            <p-button class="col-6" styleClass="h-full w-full flex justify-content-center" label="Oui"
                                [outlined]="!client.taxationSettings.vatSubject " [raised]="true"
                                (click)="onClickVatSubject(true)" />
                            <p-button class="col-6" styleClass="h-full w-full flex justify-content-center" label="Non"
                                [outlined]="true" [raised]="true" (click)="onClickVatSubject(false)" />
                        </div>

                        @if (client.taxationSettings.vatSubject) {
                        <div @expandHeight class="w-full">
                            <!-- Date à partir de laquelle l'entreprise est assujettie à la {{ taxNameLabel }} -->
                            <div class="flex align-items-center">
                                <div class="col-4">
                                    Depuis quand ? *
                                </div>
                                <div class="col-8">
                                    <p-datepicker formControlName="vatDateFrom" dateFormat="dd/mm/yy" [showIcon]="true"
                                        appendTo="body" [required]="true"></p-datepicker>
                                </div>
                            </div>

                            <!-- Taux de TVA par défaut -->
                            <div class="flex align-items-center">
                                <div class="col-4">
                                    Taux de {{ vatName }} par défaut *
                                </div>
                                <div class="col-8">
                                    <p-select [options]="taxCodes" formControlName="vatDefault" dataKey="code"
                                        appendTo="body" placeholder="Taux">
                                        <ng-template let-tax pTemplate="tax">
                                            <span>{{tax.rate}}%</span>
                                        </ng-template>
                                        <ng-template let-tax pTemplate="selectedtax">
                                            <span>{{tax.rate}}%</span>
                                        </ng-template>
                                    </p-select>
                                </div>
                            </div>
                        </div>
                        }

                        <!-- Retour / sauvegarde -->
                        <div class="col-12 flex justify-content-between">
                            <p-button type="button" severity="secondary" label="Retour" [rounded]="true"
                                (onClick)="previous()"></p-button>
                            <p-button type="button" label="Suivant" [rounded]="true"
                                [disabled]="client.taxationSettings.vatSubject && !form.get('vatDefault')?.value"
                                (onClick)="next()"></p-button>
                        </div>

                    </div>
                    }

                    <!-- Étape de saisie des données comptables de la société -->
                    @case (4) {

                    <div class="w-full">

                        <div class="col-12 flex flex-column align-items-center justify-content-center text-center">
                            <h2>“Ce ne sont pas les poètes ni les romanciers qui ont inventé l’écriture : ce sont les
                                comptables.”</h2>
                            <span class="-mt-3 font-italic text-xs text-400">Christos Nuessli</span>
                        </div>

                        <div class="flex align-items-center">
                            <div class="col-12">
                                <p-message>Ne modifiez les paramètres ci-dessous que si vous êtes sûr de vous, sinon
                                    laissez les valeurs par défaut</p-message>
                            </div>
                        </div>

                        <!-- Type de comptabilité -->
                        <div class="flex align-items-center">
                            <div class="col-4">
                                Type de comptabilité *
                            </div>
                            <div class="col-8">
                                <p-select [options]="accountingMethods" formControlName="accountingMethod"
                                    appendTo="body" dataKey="code" placeholder="Type de comptabilité">
                                    <ng-template let-accountingMethod pTemplate="selectedItem">
                                        <span>{{accountingMethod?.label}}</span>
                                    </ng-template>
                                    <ng-template let-accountingMethod pTemplate="item">
                                        <span>{{accountingMethod.label}}</span>
                                    </ng-template>
                                </p-select>
                            </div>
                        </div>

                        <!-- Premier exercice -->
                        <div class="flex align-items-center">
                            <div class="col-4">
                                <label>Exercice en cours *</label>
                            </div>
                            <div class="col-8">
                                <div class="grid">
                                    <div class="col-6">
                                        <p-datepicker formControlName="periodDateFrom" dateFormat="dd/mm/yy"
                                            [showIcon]="true" appendTo="body" [required]="true"></p-datepicker>
                                    </div>
                                    <div class="col-6">
                                        <p-datepicker formControlName="periodDateTo" dateFormat="dd/mm/yy"
                                            [showIcon]="true" appendTo="body" [required]="true"></p-datepicker>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Étape suivante -->
                        <div class="col-12 flex justify-content-between">
                            <p-button type="button" severity="secondary" label="Retour" [rounded]="true"
                                (onClick)="previous()"></p-button>
                            <p-button type="submit" label="C'est parti !" severity="success" [rounded]="true"
                                [raised]="true"
                                [disabled]="!form.get('accountingMethod')?.value || !form.get('periodDateFrom')?.value || !form.get('periodDateTo')?.value"></p-button>
                        </div>

                    </div>
                    }

                    <!-- Étape de sélection des modules à activer -->
                    @case (5) {

                    <div class="w-full">
                        <div class="col-12 flex align-items-center justify-content-center text-center">
                            <h2>Une dernière chose avant de commencer :</h2>
                        </div>

                        <!-- <div class="flex align-items-center">
                            <div class="col-10">
                                <label>Je souhaite utiliser l'assistant de recouvrement</label>
                            </div>
                            <div class="col-2 flex justify-content-end">
                                <p-toggleswitch formControlName="recoveryActive"></p-toggleswitch>
                            </div>
                        </div>

                        <div class="flex align-items-center">
                            <div class="col-10">
                                <label>Je souhaite importer mes données bancaires</label>
                            </div>
                            <div class="col-2 flex justify-content-end">
                                <p-toggleswitch formControlName="bankingActive"></p-toggleswitch>
                            </div>
                        </div>

                        <div class="flex align-items-center">
                            <div class="col-10">
                                <label>Je souhaite utiliser la reconnaissance automatisée des factures d'achat</label>
                            </div>
                            <div class="col-2 flex justify-content-end">
                                <p-toggleswitch formControlName="ocrActive"></p-toggleswitch>
                            </div>
                        </div> -->

                        <!-- Retour / Sauvegarde -->
                        <div class="col-12 flex justify-content-between mt-3">
                            <p-button type="button" severity="secondary" label="Retour" [rounded]="true"
                                [disabled]="client.busy" (onClick)="previous()"></p-button>
                            <p-button type="submit" label="C'est parti !" [rounded]="true" [raised]="true"
                                [disabled]="client.busy"></p-button>
                        </div>

                    </div>

                    }
                    }
                </div>
            </div>
        </form>
    </div>

</div>

<p-popover #op>
    <div class="w-25rem">
        <p>
            Le nom commercial est le nom sous lequel l'entreprise est connue du public. Il peut être différent de la
            raison sociale. C'est le nom qui sera utilisé dans Biifor, et qui apparaîtra sur les documents de
            l'entreprise.
        </p>
        <p>
            S'il n'est pas renseigné, le nom commercial sera identique à la raison sociale.
        </p>
    </div>
</p-popover>

<p-popover #opBusinessContext>
    <div class="w-25rem">
        <p>
            Plus vous nous en dites sur votre société (activité, clients, fournisseurs, particularités…), plus la
            comptabilisation automatique de vos factures sera fiable.
        </p>
    </div>
</p-popover>